import React, { createContext, useContext, useState } from "react";

const SelectedYearContext = createContext();

export const SelectedYearProvider = ({ children }) => {
  const [selectedYear, setSelectedYear] = useState("2024-2025");

  return (
    <SelectedYearContext.Provider value={{ selectedYear, setSelectedYear }}>
      {children}
    </SelectedYearContext.Provider>
  );
};

export const useSelectedYear = () => {
  return useContext(SelectedYearContext);
};
